import { render, staticRenderFns } from "./CreateWeetInteractionMode.vue?vue&type=template&id=35f50e03&scoped=true"
import script from "./CreateWeetInteractionMode.vue?vue&type=script&lang=ts"
export * from "./CreateWeetInteractionMode.vue?vue&type=script&lang=ts"
import style0 from "./CreateWeetInteractionMode.vue?vue&type=style&index=0&id=35f50e03&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f50e03",
  null
  
)

export default component.exports